import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';

// Components
import { Card, InputGroup, FormControl, Button } from 'react-bootstrap';
import LoadingSpinner from '../../../components/LoadingSpinner';
import CustomPagination from '../../../components/CustomPagination';

// Functions
import hreadableDate from '../../../functions/hreadableDate';


// Constant
const CREATE_COMMENT = "CREATE_COMMENT";

const StatusComment = (props) => {
    const [comment, setComment] = useState('');
    const [validationError, setValidationError] = useState(false);

    const clearComment = () => {
        setComment('');
    }

    const sendCommentHandler = () => {
        if (comment.length >= 5) {
            props.sendComment(CREATE_COMMENT, {
                comment: comment,
                cb: clearComment
            }, clearComment);
        } else {
            setValidationError(true);
        }
    }

    const changeCommentHandler = (e) => {
        setComment(e.target.value);

        // Change validation error to false
        if (validationError)
            setValidationError(false);
    }

    return (
        <>
            <InputGroup className={styles.StatusComment}>
                <FormControl
                    type="text"
                    value={comment}
                    onChange={changeCommentHandler} isInvalid={validationError} />
                <InputGroup.Append>
                    <Button size="sm" disabled={props.loading} onClick={sendCommentHandler}>
                        <span>Enviar Comentario</span>
                        {props.loading && <LoadingSpinner size="sm" inButton />}
                    </Button>
                </InputGroup.Append>
                <FormControl.Feedback type="invalid">Comentario debe ser 5 letras o mas.</FormControl.Feedback>
            </InputGroup>
            
        </>
    )
};

const StatusItem = (props) => (
    <Card className={styles.StatusItem}>
        <h5 className={styles.StatusItem__user}>{props.user}</h5>
        <p className={styles.StatusItem__comment}>{props.comment}</p>
        <p className={styles.StatusItem__time}>{props.date}</p>
    </Card>
)

const StatusBox = (props) => {
    const [comments, setComments] = useState([]);

    useEffect(() => {
        // Order the newest to the top
        const commentsOrdered = props.comments.sort((a, b) => b.timestamp - a.timestamp);
        const items_per_page = props.pagination.items_per_page;
        const currentPage = props.pagination.current;

        // Check if pagination is needed
        if (commentsOrdered.length > items_per_page) {
            const paginationComments = commentsOrdered.filter((item, index) => {
                if (index >= (currentPage - 1) * items_per_page && index < (currentPage * items_per_page))
                    return true;

                return false;
            });

            setComments(paginationComments);

            // Update Pagination when an update is done
            const totalPages = Math.ceil(commentsOrdered.length / items_per_page);
            props.setPage(currentPage, totalPages);
        } else {
            setComments(commentsOrdered);
        }
        // eslint-disable-next-line
    }, [props.comments, props.pagination.current])

    return (
        <Card className={styles.StatusBox}>
            {comments.map(item => (
                <StatusItem
                    key={item._id}
                    user={item.name}
                    comment={item.comment}
                    date={hreadableDate(item.timestamp, true, true)} />
            ))}
            {props.pagination.total > 1 && <CustomPagination
                current={props.pagination.current}
                total={props.pagination.total}
                setPage={props.setPage}
                limit={3} />}
            <StatusComment
                loading={props.loading}
                sendComment={props.sendComment} />
        </Card>
    )
};


export default StatusBox;